// extracted by mini-css-extract-plugin
export default {"send":"Send_send__GptpO","file":"Send_file__jTHXq","smile":"Send_smile__hxS7m","form":"Send_form__rMmfG","input":"Send_input__FLFZm","button":"Send_button__0fu4u"};